<template>
    <div class="box white p-3 mb-3">
        <K2Row space-between="true" class="border-bottom mb-4">
            <K2Text align="left" bold="true" class-name="mb-3"
                    :style="{fontSize:uiVariable.fontSize.lg}">
                {{title}}
            </K2Text>
            <div v-b-toggle="id">
                <K2Icon color="black" name="expand_less" class="when-open"/>
                <K2Icon color="black" name="expand_more" class="when-closed"/>
            </div>
        </K2Row>
        <b-collapse :id="id" visible>
            <K2Editor v-model="content" @input="onInput" :passContent="content"
                      :passIsMoment="postType === 'Moment'"/>
        </b-collapse>
    </div>
</template>
<script>
import K2Row from "../../../../uiComponents/k2Row/k2Row";
import K2Text from "../../../../uiComponents/k2Text/k2Text";
import K2Icon from "../../../../uiComponents/k2Icon/k2MAIcon";
import K2Editor from "../../../../uiComponents/k2Editor/k2Editor";
import { lang } from "../../../../locale";
import uiVariable from "../../../../config/uiVariable";

export default {
    name: "ActivityNewContent",
    components: { K2Editor, K2Icon, K2Text, K2Row },
    props: ["title", "id", "onChange", "type", "postType", "passContent1", "passContent2", "passContent3", "passContent4"],
    data() {
      return {
        content: "",
        content2: "",
        content3: "",
        content4: "",
        uiVariable: uiVariable
      };
    },
    mounted() {
      this.content = this.passContent1==="undefined"?"":this.passContent1;
    },
    watch: {
      passContent1: function(value) {
        if(value!=="undefined"){
          this.content = value;
        }else{
          this.content = ""
        }
      }
    },
    methods: {
      lang,
      onInput(value) {
        if (this.type === "1") {
          this.$emit("onChange", value, `content`);
        } else {
          this.$emit("onChange", value, `content${this.type}`);

        }
      }
    }
  };
</script>